import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '../../utils/cn';
import { NavItem } from './navigation';
import { MoveRight, ChevronDown, ChevronRight } from 'lucide-react';

interface NavGroupProps {
  item: NavItem;
  onClick: () => void;
}

export function NavGroup({ item, onClick }: NavGroupProps) {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const hasChildren = item.children && item.children.length > 0;

  const handleClick = () => {
    if (hasChildren) {
      setIsOpen(!isOpen);
    } else {
      onClick();
    }
  };

  return (
    <div className="space-y-4">
      <button
        onClick={handleClick}
        className={cn(
          "w-full flex items-center justify-between gap-4",
          "text-condo-light hover:text-white transition-colors",
          "focus:outline-none focus:ring-2 focus:ring-condo-light focus:ring-offset-2 focus:ring-offset-condo-dark"
        )}
      >
        <div className="flex items-center gap-4">
          <MoveRight className="h-6 w-6" />
          <span className="text-2xl font-light">{item.label}</span>
        </div>
        {hasChildren && (
          isOpen ? (
            <ChevronDown className="h-5 w-5" />
          ) : (
            <ChevronRight className="h-5 w-5" />
          )
        )}
      </button>

      {hasChildren && isOpen && (
        <div className="pl-10 space-y-4">
          {item.children!.map((child: NavItem) => (
            <Link
              key={child.to}
              to={child.to}
              onClick={onClick}
              className={cn(
                "block text-xl font-light",
                "text-condo-light/80 hover:text-white transition-colors",
                "focus:outline-none focus:ring-2 focus:ring-condo-light focus:ring-offset-2 focus:ring-offset-condo-dark",
                location.pathname === child.to && "text-condo-light font-normal"
              )}
            >
              {child.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}